var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.812 7.548a2.493 2.493 0 0 1 .091 1.644l5.243 3.206a2.5 2.5 0 1 1-.732.724l-4.976-3.043a2.5 2.5 0 1 1-.184-3.36l4.984-3.154a2.5 2.5 0 1 1 .6.802L4.812 7.549Z"
  })));
};
export default SvgShareIcon;